import { render, staticRenderFns } from "./fieldBsSwitch.vue?vue&type=template&id=4e104f92&"
import script from "./fieldBsSwitch.vue?vue&type=script&lang=js&"
export * from "./fieldBsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports